var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconChainDisconnected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7866 9.71338C11.7866 9.43724 12.0105 9.21338 12.2866 9.21338H14C14.2761 9.21338 14.5 9.43724 14.5 9.71338C14.5 9.98952 14.2761 10.2134 14 10.2134H12.2866C12.0105 10.2134 11.7866 9.98952 11.7866 9.71338Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71338 11.7866C9.98952 11.7866 10.2134 12.0105 10.2134 12.2866V14C10.2134 14.2761 9.98952 14.5 9.71338 14.5C9.43724 14.5 9.21338 14.2761 9.21338 14V12.2866C9.21338 12.0105 9.43724 11.7866 9.71338 11.7866Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2866 11.2863C11.4818 11.0911 11.7984 11.0911 11.9937 11.2863L13.2804 12.573C13.4756 12.7683 13.4756 13.0849 13.2804 13.2801C13.0851 13.4754 12.7685 13.4754 12.5733 13.2801L11.2866 11.9934C11.0913 11.7982 11.0913 11.4816 11.2866 11.2863Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6.28662C1.5 6.01048 1.72386 5.78662 2 5.78662H3.71333C3.98948 5.78662 4.21333 6.01048 4.21333 6.28662C4.21333 6.56276 3.98948 6.78662 3.71333 6.78662H2C1.72386 6.78662 1.5 6.56276 1.5 6.28662Z",
    className: "icon-fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28662 1.5C6.56276 1.5 6.78662 1.72386 6.78662 2V3.71333C6.78662 3.98948 6.56276 4.21333 6.28662 4.21333C6.01048 4.21333 5.78662 3.98948 5.78662 3.71333V2C5.78662 1.72386 6.01048 1.5 6.28662 1.5Z",
    className: "icon-fill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.71969 2.71969C2.91495 2.52443 3.23153 2.52443 3.4268 2.71969L4.71346 4.00636C4.90872 4.20162 4.90872 4.5182 4.71346 4.71346C4.5182 4.90872 4.20162 4.90872 4.00636 4.71346L2.71969 3.4268C2.52443 3.23153 2.52443 2.91495 2.71969 2.71969Z",
    className: "icon-fill"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.90708 7.09296C6.19998 7.38585 6.19998 7.86073 5.90708 8.15362L4.48508 9.57562C3.93531 10.1254 3.93531 11.0172 4.48508 11.567C5.03486 12.1167 5.92665 12.1167 6.47642 11.567L7.89842 10.145C8.19132 9.85207 8.66619 9.85207 8.95908 10.145C9.25198 10.4379 9.25198 10.9127 8.95908 11.2056L7.53708 12.6276C6.40152 13.7632 4.55998 13.7632 3.42442 12.6276C2.28886 11.4921 2.28886 9.65052 3.42442 8.51496L4.84642 7.09296C5.13932 6.80007 5.61419 6.80007 5.90708 7.09296Z",
    className: "icon-fill"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5516 4.44822C11.0018 3.89845 10.11 3.89845 9.56024 4.44822L8.13824 5.87022C7.84535 6.16311 7.37047 6.16311 7.07758 5.87022C6.78469 5.57733 6.78469 5.10245 7.07758 4.80956L8.49958 3.38756C9.63514 2.252 11.4767 2.252 12.6122 3.38756C13.7478 4.52312 13.7478 6.36466 12.6122 7.50022L11.1902 8.92222C10.8973 9.21511 10.4225 9.21511 10.1296 8.92222C9.83669 8.62933 9.83669 8.15445 10.1296 7.86156L11.5516 6.43956C12.1014 5.88979 12.1014 4.99799 11.5516 4.44822Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChainDisconnected);
export default __webpack_public_path__ + "static/media/icon-chain-disconnected.ffda1301a7ff690b1c6c30cc96848ce1.svg";
export { ForwardRef as ReactComponent };